import React from 'react';
import { TextFieldProps } from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { IconButton, InputAdornment } from '@mui/material';
import { Input } from './Input';

type Props = TextFieldProps;

const ShowHidePassword = ({
  handlePasswordVisibility,
  togglePasword
}: {
  handlePasswordVisibility: () => void;
  togglePasword: boolean;
}) => {
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  return (
    <div>
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={() => handlePasswordVisibility()}
          onMouseDown={handleMouseDownPassword}
        >
          {togglePasword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    </div>
  );
};

export const PasswordInput: React.FC<Props> = (props) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handlePasswordVisibility = () => setShowPassword((show) => !show);

  return (
    <Input
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <ShowHidePassword
            handlePasswordVisibility={handlePasswordVisibility}
            togglePasword={showPassword}
          />
        )
      }}
    />
  );
};
